export function formatNumber(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '0';
  }

  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(num)) {
    return '0';
  }

  return num.toLocaleString('en-US');
}

export function formatBalance(value: string | number | null | undefined): string {
  if (!value || value === '0') {
    return '0';
  }

  const num = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(num)) {
    return '0';
  }

  // Convert from wei to ether and format
  const ether = num / 1e18;

  if (ether === 0) {
    return '0';
  }

  // If very small, use scientific notation
  if (ether < 0.000001) {
    return ether.toExponential(2);
  }

  // Otherwise format with appropriate decimals
  if (ether < 1) {
    return ether.toFixed(6);
  }

  return ether.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  });
}

export function formatCompilerVersion(
  language: string | null | undefined,
  version: string | null | undefined
): string {
  // Capitalize language, handle special cases
  let lang = 'Solidity';
  if (language) {
    const lower = language.toLowerCase();
    if (lower === 'stylus_rust') {
      lang = 'Stylus Rust';
    } else {
      lang = language.charAt(0).toUpperCase() + language.slice(1).toLowerCase();
    }
  }

  // Format version - extract just the version number without commit hash
  let ver = '';
  if (version) {
    // Remove 'v' prefix if exists
    let cleanVersion = version.startsWith('v') ? version.slice(1) : version;

    // Remove commit hash (everything after '+')
    cleanVersion = cleanVersion.split('+')[0];

    ver = `v${cleanVersion}`;
  }

  return ver ? `${lang} ${ver}` : lang;
}
